import { Box, Theme, useMediaQuery } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { extend, locale } from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import utc from "dayjs/plugin/utc";
import React, { useContext, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";

import { LanguageContext } from "src/contexts/language";

import Header from "./Header";
import "dayjs/locale/fr";
import "dayjs/locale/en";
import MobileSwitchView from "./mobile/MobileSwitchView";

extend(utc);
extend(localizedFormat);

const SharedLayout = () => {
    const { language } = useContext(LanguageContext);
    const [localeLang] = useState(language.split("-")[0].toLowerCase() || "fr");

    useEffect(() => {
        locale(localeLang);
    }, [language]);

    const isMobile = useMediaQuery((theme: Theme) =>
        theme.breakpoints.down("md"),
    );

    return (
        <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale={localeLang}
        >
            <Box display="flex" flexDirection="column" height="100%">
                <Header />
                <Box flex="1">
                    <Outlet />
                </Box>
                {isMobile && <MobileSwitchView />}
            </Box>
        </LocalizationProvider>
    );
};

export default SharedLayout;
